export const INTERNAL_CONFIG = {
  floorSize: 300,
  modelPercentageOfViewport: 80,
};

export const ORBIT_CONTROLS_DISTANCES = {
  maxDistance: 4,
  minDistance: 1,
};